// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BYKcl .SdFaS{max-width:1248px;max-width:78rem;margin-right:auto;margin-left:auto}@media(max-width:1439px){.BYKcl .SdFaS{max-width:calc(100% - 4rem)}}@media(max-width:767px){.BYKcl .SdFaS{max-width:calc(100% - 2rem)}}.BYKcl{padding:4rem 0}@media(max-width:767px){.BYKcl{padding-top:2.25rem;padding-bottom:0}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"container": "BYKcl",
	"heading": "SdFaS"
};
module.exports = exports;
